"use client";
import { createContext, useState, PropsWithChildren } from "react";

type sideBarValuesType = {
  expand: boolean;
  openExpand: () => void;
  closeExpand: () => void;
};

const initialData: sideBarValuesType = {
  expand: true,
  openExpand: () => {},
  closeExpand: () => {},
};

export const SidebarMenuContext = createContext(initialData);

function SidebarMenuProvider({ children }: PropsWithChildren) {
  const [expand, setExpand] = useState<boolean>(initialData.expand);
  const openExpand = () => setExpand(true);
  const closeExpand = () => setExpand(false);
  const values = {
    expand,
    openExpand,
    closeExpand,
  };
  return (
    <SidebarMenuContext.Provider value={values}>
      {children}
    </SidebarMenuContext.Provider>
  );
}

export default SidebarMenuProvider;
